// extracted by mini-css-extract-plugin
module.exports = {"text":"_103a151b99--text--_U_r1"};